function formatMonth(year, month) {
  return `${year}-${String(month).padStart(2, '0')}`
}

export default function MonthNavigator({ value, onChange }) {
  const [year, month] = value.split('-').map(Number)

  const shift = (delta) => {
    const d = new Date(year, month - 1 + delta, 1)
    onChange(formatMonth(d.getFullYear(), d.getMonth() + 1))
  }

  const today = new Date()
  const isCurrent = year === today.getFullYear() && month === today.getMonth() + 1

  return (
    <div className="mb-4 flex items-center justify-between gap-2">
      <button
        type="button"
        onClick={() => shift(-1)}
        className="h-16 w-16 rounded-2xl bg-navy-700 text-4xl font-bold text-white"
        aria-label="上一個月"
      >
        ‹
      </button>
      <div className="text-center">
        <div className="text-3xl font-bold text-white">{year} 年 {month} 月</div>
        {isCurrent && <div className="text-xl text-green-300">✓ 這個月</div>}
      </div>
      <button
        type="button"
        onClick={() => shift(1)}
        className="h-16 w-16 rounded-2xl bg-navy-700 text-4xl font-bold text-white"
        aria-label="下一個月"
      >
        ›
      </button>
    </div>
  )
}
